import { lazy } from "react";

// project import
// import { useLocation } from "react-router";
const Dashboard = lazy(() => import("layouts/dashboard"));
const UserRegistration = lazy(() => import("layouts/pages/UserRegistration"));
const JobForm = lazy(() => import("layouts/pages/JobForm"));
// import JobSearch from "layouts/pages/JobSearch";
const Workflow = lazy(() => import("layouts/pages/Workflow"));
const ProfilePage = lazy(() => import("layouts/pages/ProfilePage"));
// import JobDetails from "layouts/pages/JobDetails";
const CompanyProfile = lazy(() => import("layouts/pages/CompanyProfile"));
const Users = lazy(() => import("layouts/pages/Users"));
const AccessControl = lazy(() => import("layouts/configs/AccessControl"));
// import SingleProfile from "layouts/pages/SingleProfile";
const Billing = lazy(() => import("layouts/billing"));
// import LaunchPage from "layouts/pages/LaunchPage";
const Configurations = lazy(() => import("layouts/pages/configurations/Configurations"));
const SMTPConfig = lazy(() => import("layouts/pages/configurations/SMTPConfig"));
const ApplicantDetails = lazy(() => import("layouts/pages/ApplicantDetails"));
const UserProfile = lazy(() => import("layouts/pages/UserProfile"));
const ResumeDetails = lazy(() => import("layouts/pages/ResumeDetails"));
const MainPageContent = lazy(() => import("layouts/pages/configurations/MainPageContent"));

const MainRoutes = (access_list_data) => {
  // const get_access = (module_name, access_type) => {
  //   return Boolean(access_list_data?.find((item) => item.module_name === module_name))
  //     ? access_list_data?.find((item) => item.module_name === module_name)[access_type]
  //     : false;
  // };

  return [
    // get_access("Dashboard", "read_access") &&
    {
      path: "/dashboard",
      element: <Dashboard />,
    },
    {
      path: "/user-registration",
      element: <UserRegistration />,
    },
    {
      path: "/job-creation",
      element: <JobForm />,
    },
    {
      path: "/workflow",
      element: <Workflow />,
    },
    {
      path: "/profile",
      element: <ProfilePage />,
    },
    {
      path: "/company-profile",
      element: <CompanyProfile />,
    },
    {
      path: "/users",
      element: <Users />,
    },
    {
      path: "/access-control",
      element: <AccessControl />,
    },
    {
      path: "/billing",
      element: <Billing />,
    },
    {
      path: "/configurations",
      element: <Configurations />,
    },
    {
      path: "/system-configuration",
      element: <SMTPConfig />,
    },
    {
      path: "/applicant-details",
      element: <ApplicantDetails />,
    },
    {
      path: "/user-profile",
      element: <UserProfile />,
    },
    {
      path: "/resume-data",
      element: <ResumeDetails />,
    },
    {
      path: "/content-management",
      element: <MainPageContent />,
    },
    
  ]?.filter(Boolean);
};

export default MainRoutes;
